import { Route, Routes } from 'react-router-dom';
import ExportOffers from './export-offers/ExportOffers';
import { hasAccessRight } from '../../utils/Functions';
import { AdminAclEnum } from '../../enum/AdminAclEnum';

export function ExportRoutes() {
    return (
        <Routes>
            {hasAccessRight(AdminAclEnum.EXPORT) && <Route path="export-offers" element={<ExportOffers />} />}
        </Routes>
    );
}
